<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         width="10"
         height="13.444"
         viewBox="0 0 10 13.444">
        <g data-name="组 131"
           transform="translate(0)">
            <path data-name="路径 92"
                  d="M302.562,416.971a2.882,2.882,0,0,1,0,4.072l-2.036-2.036Z"
                  transform="translate(-300.526 -412.286)" />
            <path data-name="路径 91"
                  d="M294.972,412.57a6.154,6.154,0,0,1,0,8.706l-.685-.685a5.184,5.184,0,0,0,0-7.335Z"
                  transform="translate(-290.617 -410.2)" />
            <path data-name="路径 90"
                  d="M287.928,408.747l.685-.685a9.517,9.517,0,0,1,0,13.444l-.685-.685A8.546,8.546,0,0,0,287.928,408.747Z"
                  transform="translate(-281.891 -408.062)" />
        </g>
    </svg>

</template>

<script>
import anime from 'animejs'
export default {
    data() {
        return {
            record: null,
            targets: null
        }
    },
    methods: {
        start(duration = this.maxDuration) {
            if (this.record) {
                this.record.restart()
            } else {
                this.record = anime({
                    targets: this.targets,
                    easing: 'easeInOutSine',
                    opacity: [0, 1],
                    delay: anime.stagger(350),
                    duration: 750,
                    loop: true
                })
            }
        },
        stop() {
            this.record.pause()
            this.targets.forEach(el => el.style = '')
        }
    },
    mounted() {
        this.targets = Array.prototype.slice.call(this.$el.querySelectorAll('path'), 1)
    }
}
</script>

<style scoped lang='less'>
</style>